
//react moveable- all support except layers. have zindex manually

import { useState, useRef, useEffect, useCallback } from 'react';
import { ChevronDown, AlignJustify, Printer, Download, LogOut, Circle, X, ArrowBigLeftDash, Pen, Eraser, Trash2 ,Info,TypeOutline  } from 'lucide-react';
import axios from 'axios';
import html2canvas from 'html2canvas';
import LayerPanelMainCanvas from './LayerPanelMainCanvas';
import CanvasItem from './CanvasItem';
import TextItem from './TextItem';

import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import { Stage, Layer, Text ,Line } from 'react-konva';
import useImage from 'use-image';
// Add this import at the top of your file
import jsPDF from 'jspdf';

// Then modify the handleDownload function to use the imported jsPDF

import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
// import { Info, X } from "lucide-react";

const API_BASE_URL = `${process.env.REACT_APP_BASE_URL}`
// const API_BASE_URL = 'https://circular-frame-work-backend.onrender.com';
// const API_BASE_URL = 'http://localhost:5000';

export default function Framebuilder() {

  // Mock location data since we can't use useLocation
  const formData = {
    procedureName: 'Left proximal tibia correction',
    patientName: 'Any one',
    side: 'Left'
  };
  const [apiAssets, setApiAssets] = useState([]);
  const [categories, setCategories] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isEditMode, setIsEditMode] = useState(true);
  const [expandedSections, setExpandedSections] = useState({});
  const [canvas, setCanvas] = useState([]);
  const [leftCanvas, setLeftCanvas] = useState([]);
  const [rightCanvas, setRightCanvas] = useState([]);
  const [draggedItem, setDraggedItem] = useState(null);
  const canvasRef = useRef(null);
  const leftCanvasRef = useRef(null);
  const rightCanvasRef = useRef(null);
  const [canvasItems, setCanvasItems] = useState([]);



  const [selectedIds, setSelectedIds] = useState([]);

  const printRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  // Add these state variables to your component
const [isDrawing, setIsDrawing] = useState(false);
const [lines, setLines] = useState([]);
const [currentLine, setCurrentLine] = useState(null);
const [drawingColor, setDrawingColor] = useState('#000000');
const [drawingWidth, setDrawingWidth] = useState(3);
const [drawingMode, setDrawingMode] = useState('off'); // 'off', 'pen', or 'eraser'
const [mousePosLeft, setMousePosLeft] = useState({ x: 0, y: 0 });
const [mousePosMain, setMousePosMain] = useState({ x: 0, y: 0 });
const [mousePosRight, setMousePosRight] = useState({ x: 0, y: 0 });
  // Mock navigation function
  const navigate = useNavigate();

  const [expandedSubsections, setExpandedSubsections] = useState({});
  const [isRotating, setIsRotating] = useState(false);
  // const rotateInfoRef = useRef({ itemId: null, canvasType: null, center: null });
 const [dropdownOpen, setDropdownOpen] = useState(false);
const [open, setOpen] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  // const [loading, setLoading] = useState(false);
  // const [error, setError] = useState(null);

  const pencilCursor = "url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggZD0iTTE3IDNhMi44MjggMi44MjggMCAxIDEgNCA0TDcuNSAyMC41IDIgMjJsMS41LTUuNUwxNyAzLXoiPjwvcGF0aD48L3N2Zz4='), auto";


  // Add these functions to your main Framebuilder component:

const toggleLock = (itemId) => {
  setCanvas(prev =>
    prev.map(item =>
      item.id === itemId ? { ...item, locked: !item.locked } : item
    )
  );
};

const toggleLeftLock = (itemId) => {
  setLeftCanvas(prev =>
    prev.map(item =>
      item.id === itemId ? { ...item, locked: !item.locked } : item
    )
  );
};

const toggleRightLock = (itemId) => {
  setRightCanvas(prev =>
    prev.map(item =>
      item.id === itemId ? { ...item, locked: !item.locked } : item
    )
  );
};

  const togglePenDropdown = () => {
    const isPenActive = drawingMode === 'pen';
    setDropdownOpen(!isPenActive); // Open if not active, close if already active
    setDrawingMode(isPenActive ? 'off' : 'pen');
  };

  const handleEraser = () => {
    setDrawingMode('eraser');
    setDropdownOpen(false);
  };
  const fetchPDF = async () => {
  try {
    setLoading(true);
    setError(null);

    const res = await axios.get(`${API_BASE_URL}/getpdf`, {
      responseType: "blob",
    });

    const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
    setPdfUrl(url);
    setOpen(true);
  } catch (err) {
    console.error("Error fetching PDF:", err);
    setError("Failed to load PDF.");
  } finally {
    setLoading(false);
  }
};

  const handleClear = () => {
    setLines([]);
    setDropdownOpen(false);
  };
  const moveItemZIndex = (itemId, direction) => {
    setCanvas(prev => {
      const index = prev.findIndex(item => item.id === itemId);
      if (index === -1) return prev;

      const updated = [...prev];
      const currentZ = updated[index].zIndex || 1;

      if (direction === 'up') {
        updated[index].zIndex = currentZ + 1;
      } else if (direction === 'down' && currentZ > 0) {
        updated[index].zIndex = currentZ - 1;
      }

      return [...updated];
    });
  };
const handleMouseDown = (e, canvasType) => {
  if (drawingMode === 'off') return;
  
  const pos = e.target.getStage().getPointerPosition();
  setCurrentLine({
    points: [pos.x, pos.y],
    color: drawingMode === 'eraser' ? '#ffffff' : drawingColor,
    width: drawingWidth,
    canvasType
  });
  setIsDrawing(true);
};

const handleMouseMove = (e, canvasType) => {
  if (!isDrawing || !currentLine || currentLine.canvasType !== canvasType) return;
  
  const stage = e.target.getStage();
  const point = stage.getPointerPosition();
  
  setCurrentLine({
    ...currentLine,
    points: [...currentLine.points, point.x, point.y]
  });
};

const handleMouseUp = (canvasType) => {
  if (!isDrawing || !currentLine || currentLine.canvasType !== canvasType) return;
  
  setLines([...lines, currentLine]);
  setCurrentLine(null);
  setIsDrawing(false);
};
  const toggleVisibility = (itemId) => {
    setCanvas(prev =>
      prev.map(item =>
        item.id === itemId ? { ...item, visible: !item.visible } : item
      )
    );
  };


  const moveLeftItemZIndex = (itemId, direction) => {
    setLeftCanvas(prev => {
      const index = prev.findIndex(item => item.id === itemId);
      if (index === -1) return prev;

      const updated = [...prev];
      const currentZ = updated[index].zIndex || 1;

      if (direction === 'up') {
        updated[index].zIndex = currentZ + 1;
      } else if (direction === 'down' && currentZ > 0) {
        updated[index].zIndex = currentZ - 1;
      }

      return [...updated];
    });
  };

  const moveRightItemZIndex = (itemId, direction) => {
    setRightCanvas(prev => {
      const index = prev.findIndex(item => item.id === itemId);
      if (index === -1) return prev;

      const updated = [...prev];
      const currentZ = updated[index].zIndex || 1;

      if (direction === 'up') {
        updated[index].zIndex = currentZ + 1;
      } else if (direction === 'down' && currentZ > 0) {
        updated[index].zIndex = currentZ - 1;
      }

      return [...updated];
    });
  };

  const toggleLeftVisibility = (itemId) => {
    setLeftCanvas(prev =>
      prev.map(item =>
        item.id === itemId ? { ...item, visible: !item.visible } : item
      )
    );
  };

  const toggleRightVisibility = (itemId) => {
    setRightCanvas(prev =>
      prev.map(item =>
        item.id === itemId ? { ...item, visible: !item.visible } : item
      )
    );
  };

  useEffect(() => {
    const fetchAssets = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE_URL}/api/assets`,);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log('Full API Response:', data);

        const assetsArray = data.data || [];
        console.log('Assets Array:', assetsArray);

        setApiAssets(assetsArray);

        const groupedCategories = {};

        assetsArray.forEach((asset) => {
          const parentId = asset.category_parent_id;
          const parentName = asset.parent_category_name || asset.category_name;

          // Create or get the parent group
          if (!groupedCategories[parentName]) {
            groupedCategories[parentName] = {
              parentAssets: [],
              subcategories: {}
            };
          }

          if (parentId) {
            // This asset belongs to a subcategory
            const subName = asset.category_name;
            if (!groupedCategories[parentName].subcategories[subName]) {
              groupedCategories[parentName].subcategories[subName] = [];
            }
            groupedCategories[parentName].subcategories[subName].push(asset);
          } else {
            // Asset belongs directly to the parent category
            groupedCategories[parentName].parentAssets.push(asset);
          }
        });



        console.log('Grouped Categories:', groupedCategories);
        setCategories(groupedCategories);

        const newExpandedSections = {};
        Object.keys(groupedCategories).forEach(categoryName => {
          const sectionKey = categoryName.toLowerCase().replace(/\s+/g, '');
          newExpandedSections[sectionKey] = false;
        });
        setExpandedSections(newExpandedSections);

      } catch (err) {
        console.error('Error fetching assets:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAssets();
  }, []);

  const handleLogout = () => {
    navigate('/');
    localStorage.removeItem("authToken");
    console.log('User logged out');
    setShowModal(false);
  };

  // const initRotate = (e, itemId, canvasType) => {
  //   e.evt.preventDefault(); 
  //   e.evt.stopPropagation();

  //   const canvasList =
  //     canvasType === 'left'
  //       ? leftCanvas
  //       : canvasType === 'right'
  //         ? rightCanvas
  //         : canvas;

  //   const item = canvasList.find((i) => i.id === itemId);
  //   if (!item) return;

  //   const center = {
  //     x: item.position.x + item.width / 2,
  //     y: item.position.y + item.height / 2,
  //   };

  //   rotateInfoRef.current = { itemId, canvasType, center };
  //   setIsRotating(true);
  // };


  // useEffect(() => {
  //   const handleMouseMove = (e) => {
  //     if (!isRotating) return;

  //     const { itemId, canvasType, center } = rotateInfoRef.current;

  //     // Get the correct canvas ref
  //     let canvasEl = null;
  //     if (canvasType === 'left') canvasEl = leftCanvasRef.current;
  //     else if (canvasType === 'right') canvasEl = rightCanvasRef.current;
  //     else canvasEl = canvasRef.current;

  //     if (!canvasEl) return;

  //     const canvasRect = canvasEl.getBoundingClientRect();
      
  //     // Convert mouse position to canvas-local coordinates
  //     const localMouseX = e.clientX - canvasRect.left;
  //     const localMouseY = e.clientY - canvasRect.top;

  //     // Convert center to local space (center is already in canvas coordinates)
  //     const localCenter = {
  //       x: center.x,
  //       y: center.y,
  //     };

  //     // Calculate angle in degrees
  //     const angle =
  //       Math.atan2(localMouseY - localCenter.y, localMouseX - localCenter.x) * (180 / Math.PI);

  //     console.log('Rotating:', { angle, itemId, canvasType, localMouseX, localMouseY, localCenter });

  //     handleItemUpdate(itemId, { rotate: angle }, canvasType);
  //   };

  //   const handleMouseUp = () => {
  //     if (isRotating) {
  //       setIsRotating(false);
  //       // Clear the rotation info when done
  //       rotateInfoRef.current = { itemId: null, canvasType: null, center: null };
  //     }
  //   };

  //   // Only add event listeners when rotating
  //   if (isRotating) {
  //     window.addEventListener('mousemove', handleMouseMove);
  //     window.addEventListener('mouseup', handleMouseUp);
  //   }

  //   return () => {
  //     window.removeEventListener('mousemove', handleMouseMove);
  //     window.removeEventListener('mouseup', handleMouseUp);
  //   };
  // }, [isRotating]);


  const convertApiAssetToSidebarItem = (asset) => {
    const imageUrl = `${API_BASE_URL}/uploads/${asset.image}`;



    return {
      id: `api-asset-${asset.id}`,
      type: 'image',
      label: asset.name,
      isSelected: false,
      icon: (
        <img
          src={imageUrl}
          alt={asset.name}
          width={24}
          height={24}
          className="w-6 h-6 object-contain rounded"
        />
      ),
      imageUrl: imageUrl,
      content: 'api-asset-img',
      apiAsset: true
    };
  };


  const toggleSection = (section) => {
    setExpandedSections({
      ...expandedSections,
      [section]: !expandedSections[section]
    });
  };

  const toggleSubsection = (sectionKey) => {
    setExpandedSubsections(prev => ({
      ...prev,
      [sectionKey]: !prev[sectionKey]
    }));
  };

  const handleDragStart = (e, item, canvasType) => {
    
    
    console.log("Drag started:", { item, canvasType });
    e.dataTransfer.effectAllowed = 'copyMove';
    setDraggedItem({ ...item, fromCanvas: canvasType });

  };

  const getMaxZIndex = (items) => {
    return items.reduce((max, item) => Math.max(max, item.zIndex || 1), 0);
  };
  const handleDrop = (e, canvasType = 'main') => {
    e.preventDefault();
    e.stopPropagation();


    if (drawingMode !== 'off') {
      return;
    }

    if (!draggedItem) return;


    const canvasBounds = {
      left: { width: 128, height: 420 },
      right: { width: 128, height: 420 },
   main: { width: 576, height: 420 }
    };

    const { width: canvasWidth, height: canvasHeight } = canvasBounds[canvasType] || canvasBounds.main;
    const canvasRect = (
      canvasType === 'left' ? leftCanvasRef.current :
        canvasType === 'right' ? rightCanvasRef.current :
          canvasRef.current
    ).getBoundingClientRect();

    const stageOffset = canvasType === 'main' ? { x: -80, y: -105 } : { x: -60, y: -105 };
    const setCanvasState = (
      canvasType === 'left' ? setLeftCanvas :
        canvasType === 'right' ? setRightCanvas :
          setCanvas
    );


    const rawX = e.clientX - canvasRect.left - 75 - stageOffset.x;
    const rawY = e.clientY - canvasRect.top - 75 - stageOffset.y;

    if (draggedItem.type === 'text') {
      // Handle text item drop
      const newItem = {
        ...draggedItem,
        id: `canvas-item-${Date.now()}`,
        position: { x: rawX, y: rawY },
        width: 120,
        height: 50,
        rotate: 0,
        zIndex: getMaxZIndex(
          canvasType === 'left' ? leftCanvas :
            canvasType === 'right' ? rightCanvas :
              canvas
        ) + 1,
        locked: false,
        text: 'Type here',
        fontSize: 16,
        fill: '#000000',
        visible: true,
      };

      setCanvasState(prev => [newItem, ...prev]);
      setDraggedItem(null);
      return;
    }

    const img = new Image();
    img.src = draggedItem.imageUrl;
    img.onload = () => {
      let width = img.width;
      let height = img.height;



      if (width > 120) {
        const scale = 128 / width;
        width = 140;
        height = height * scale;
      } else if (height > 420) {
        const scale = 400 / height;
        height = 450;
        width = width * scale;
      } else if (width < 24 || height < 24) {
        const scale = Math.max(24 / width, 24 / height);
        width = width * scale;
        height = height * scale;
      }
      else if (width > 100 && height > 450) {
        // Special case: resize to fit canvas (120x420)
        const widthScale = 120 / width;
        const heightScale = 420 / height;
        const scale = Math.min(widthScale, heightScale);
        width = width * scale;
        height = height * scale;
      }
      else if (width > 100 || height > 100) {
        // Scale down to at most 100px (maintain aspect ratio)
        const scale = Math.min(100 / width, 100 / height);
        width = width * scale;
        height = height * scale;
      }

      // Ensure image stays fully visible
      const x = Math.max(0, Math.min(rawX, canvasWidth - width));
      const y = Math.max(0, Math.min(rawY, canvasHeight - height));

      // Create new canvas item
      const newItem = {
        ...draggedItem,
        id: `canvas-item-${Date.now()}`,
        position: { x, y },
        width,
        height,
        rotate: 0,
        zIndex: getMaxZIndex(
          canvasType === 'left' ? leftCanvas :
            canvasType === 'right' ? rightCanvas :
              canvas
        ) + 1,
        locked: false, // ADD THIS LINE
        visible: true,
      };

      setCanvasState(prev => [newItem, ...prev]);
      setDraggedItem(null);
    };
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'copy';
  };

  const handleItemUpdate = (itemId, newData, canvasType = 'main') => {
    let setCanvasState;

    switch (canvasType) {
      case 'left':
        setCanvasState = setLeftCanvas;
        break;
      case 'right':
        setCanvasState = setRightCanvas;
        break;
      default:
        setCanvasState = setCanvas;
    }

    setCanvasState(prevCanvas => {
      // When an item is selected/moved, bring it to the front
      if (newData.isSelected || newData.position || newData.width || newData.height) {
        const maxZIndex = prevCanvas.reduce(
          (max, item) => Math.max(max, item.zIndex || 1),
          1
        );

        return prevCanvas.map(item => {
          if (item.id === itemId) {
            return {
              ...item,
              ...newData,
              zIndex: maxZIndex + 1
            };
          }
          // Reset z-index of other items if needed
          return item;
        });
      }

      // For other updates (like rotation)
      return prevCanvas.map(item => {
        if (item.id === itemId) {
          return {
            ...item,
            ...newData
          };
        }
        return item;
      });
    });
  };

  const handleItemDelete = (itemId, canvasType = 'main') => {
    let setCanvasState, getCanvasState;

    switch (canvasType) {
      case 'left':
        setCanvasState = setLeftCanvas;
        getCanvasState = () => leftCanvas;
        break;
      case 'right':
        setCanvasState = setRightCanvas;
        getCanvasState = () => rightCanvas;
        break;
      default:
        setCanvasState = setCanvas;
        getCanvasState = () => canvas;
    }

    const canvasList = getCanvasState();
    const itemToDelete = canvasList.find((item) => item.id === itemId);
    if (itemToDelete) {
      console.log(`Deleted asset: ${itemToDelete.label || itemToDelete.id}`);
    }

    setCanvasState(prevCanvas => prevCanvas.filter(item => item.id !== itemId));
  };

  const handleKeyDown = (e) => {
    // Key handling logic if needed
  };

  const handlePrint = () => {
  const printStyles = `
    <style id="print-styles">
      @media print {
        /* Force background colors and borders to print */
        * {
          -webkit-print-color-adjust: exact !important;
          color-adjust: exact !important;
          print-color-adjust: exact !important;
        }
        
        body * {
          visibility: hidden;
        }
        
        [data-print-content="true"],
        [data-print-content="true"] * {
          visibility: visible;
        }
        
        [data-print-content="true"] {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
        }
        
        /* Hide other elements during print */
        .no-print {
          display: none !important;
        }
        
        /* Ensure canvases have visible borders and backgrounds */
        [data-print-content="true"] .bg-gray-200 {
          background-color: #e5e7eb !important;
          -webkit-print-color-adjust: exact !important;
        }
        
        [data-print-content="true"] .bg-white {
          background-color: white !important;
          -webkit-print-color-adjust: exact !important;
        }
        
        [data-print-content="true"] .border-2 {
          border: 2px solid #d1d5db !important;
          -webkit-print-color-adjust: exact !important;
        }
        
        [data-print-content="true"] .border-gray-300 {
          border-color: #d1d5db !important;
          -webkit-print-color-adjust: exact !important;
        }
        
        /* Force all borders to be visible */
        [data-print-content="true"] *[class*="border"] {
          -webkit-print-color-adjust: exact !important;
          color-adjust: exact !important;
        }
        
        /* Ensure shadows are visible (optional) */
        [data-print-content="true"] .shadow-sm {
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;
          -webkit-print-color-adjust: exact !important;
        }
        
        /* Page setup */
        @page {
          margin: 0.5in;
          size: A4;
        }
        
        /* Alternative: Add explicit borders for canvas elements */
        [data-print-content="true"] .w-32.h-\\[26\\.25rem\\] {
          border: 1px solid #000 !important;
          background-color: #f3f4f6 !important;
        }
        
        [data-print-content="true"] .w-96.h-\\[26\\.25rem\\] {
          border: 2px solid #000 !important;
          background-color: white !important;
        }
      }
    </style>
  `;
  
  // Insert print styles
  document.head.insertAdjacentHTML('beforeend', printStyles);
  
  // Optional: Show a message to user about browser print settings
  const userAgent = navigator.userAgent;
  const isChrome = userAgent.includes('Chrome');
  const isFirefox = userAgent.includes('Firefox');
  
  if (isChrome || isFirefox) {
    // Brief delay to ensure styles are applied
    setTimeout(() => {
      window.print();
    }, 100);
  } else {
    window.print();
  }
  
  // Clean up styles after printing
  setTimeout(() => {
    const styleElement = document.getElementById('print-styles');
    if (styleElement) {
      styleElement.remove();
    }
  }, 1000);
};

  useEffect(() => {
    const handleBeforePrint = () => {
      document.body.classList.add('printing');
    };

    const handleAfterPrint = () => {
      document.body.classList.remove('printing');
    };

    window.addEventListener('beforeprint', handleBeforePrint);
    window.addEventListener('afterprint', handleAfterPrint);

    return () => {
      window.removeEventListener('beforeprint', handleBeforePrint);
      window.removeEventListener('afterprint', handleAfterPrint);
    };
  }, []);

const handleDownload = async () => {
    setTimeout(async () => {
      try {
        const loadScript = (src) => {
          return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = src;
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
          });
        };

        await loadScript('https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js');
        await loadScript('https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js');

        if (!printRef.current) {
          console.error('Print reference not found');
          return;
        }

        const options = {
          scale: 3,
          useCORS: true,
          allowTaint: true,
          backgroundColor: '#ffffff',
          width: printRef.current.scrollWidth,
          height: printRef.current.scrollHeight,
          scrollX: 0,
          scrollY: 0,
          onclone: (clonedDoc) => {
            const clonedElement = clonedDoc.querySelector('[data-print-content="true"]');
            if (clonedElement) {
              // Replace text fields and textareas
              const inputs = clonedElement.querySelectorAll('input[type="text"], textarea');
              inputs.forEach(input => {
                const span = clonedDoc.createElement('span');
                span.textContent = input.value || 'N/A';
                span.style.display = 'inline-block';
                span.style.minWidth = '200px';
                span.style.backgroundColor = '#ffffff';
                span.style.fontSize = '14px';
                span.style.fontFamily = 'inherit';
                span.style.lineHeight = '1.4';
                if (input.tagName === 'TEXTAREA') {
                  span.style.whiteSpace = 'pre-wrap';
                  span.style.display = 'block';
                }
                input.parentNode.replaceChild(span, input);
              });

              // Show ONLY selected checkbox values as plain text
              const checkboxes = clonedElement.querySelectorAll('input[type="checkbox"]');
              let hasChecked = false;

              // First pass: check if any checkbox is selected
              checkboxes.forEach(checkbox => {
                if (checkbox.checked) {
                  hasChecked = true;
                }
              });

              if (!hasChecked) {
                const naSpan = clonedDoc.createElement('span');
                naSpan.textContent = 'N/A';
                naSpan.style.fontSize = '14px';
                checkboxes[0]?.closest('div')?.replaceWith(naSpan);
              } else {
                checkboxes.forEach(checkbox => {
                  const parent = checkbox.closest('label') || checkbox.parentNode;
                  if (checkbox.checked) {
                    const labelText = parent.textContent.trim();
                    const span = clonedDoc.createElement('span');
                    span.textContent = labelText;
                    span.style.fontSize = '14px';
                    span.style.minWidth = '200px';
                    checkbox.closest('div')?.replaceWith(span); 
                  } else {
                    parent.remove();
                  }
                });
              }

              
              const radioGroups = {};
              const radios = clonedElement.querySelectorAll('input[type="radio"]');
              radios.forEach(radio => {
                if (!radioGroups[radio.name]) {
                  radioGroups[radio.name] = [];
                }
                radioGroups[radio.name].push(radio);
              });

              Object.values(radioGroups).forEach(group => {
                const selected = group.find(r => r.checked);
                const container = group[0].closest('div') || group[0].parentNode;

                if (selected) {
                  const label = clonedElement.querySelector(`label[for="${selected.id}"]`);
                  const span = clonedDoc.createElement('span');
                  span.textContent = label ? label.textContent.trim() : selected.value;
                  span.style.fontSize = '14px';
                  span.style.minWidth = '200px';
                  container.replaceWith(span);
                } else {
                  
                  const naSpan = clonedDoc.createElement('span');
                  naSpan.textContent = 'N/A';
                  naSpan.style.fontSize = '14px';
                  container.replaceWith(naSpan);
                }
              });
            }
          }
        };

        const canvas = await html2canvas(printRef.current, options);
        const imgData = canvas.toDataURL('image/png', 0.5);
        const imgWidth = 210;
        const pageHeight = 297;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;

        const { jsPDF } = window.jspdf;
        const pdf = new jsPDF('p', 'mm', 'a4');

        let position = 0;

        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }

        const blob = pdf.output('blob');

        if (window.showSaveFilePicker) {
          
          const handle = await window.showSaveFilePicker({
            suggestedName: " .pdf", 
            types: [{ description: "PDF Files", accept: { "application/pdf": [".pdf"] } }]
          });
          const writable = await handle.createWritable();
          await writable.write(blob);
          await writable.close();
        } else {
          
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = " .pdf"; 
          a.click();
          URL.revokeObjectURL(url);
        }
      } catch (error) {
        if (error.name === "AbortError" || error.message.includes("aborted")) {
          console.log("Save cancelled by user.");
          return;
        }

        console.error("PDF Download failed:", error);
        alert("PDF download failed. Please try again.");
      }
    }, 100);
};


  const renderSidebarItem = (item) => {
    return (
      <div
        key={item.id}
        className="flex items-center py-2 px-2 text-white cursor-move hover:bg-sky-500 transition-colors"
        draggable
        onDragStart={(e) => {
          e.stopPropagation(); // 👈 IMPORTANT!
          e.dataTransfer.setData('text/plain', item.id); // dummy, needed for Firefox
          handleDragStart(e, item, 'sidebar');
        }}
      >
        <div className="mr-2 flex items-center gap-2 w-full">
          {item.icon}
          <span className="text-sm truncate">{item.label}</span>
        </div>
      </div>
    );
  };

  
  const textInputTool = {
    id: 'text-input-tool',
    type: 'text',
    // label: 'Text Input',
    icon: (
   <TypeOutline className="w-5 h-5 text-white" />
    ),
  };

  
  const sidebarItems = [textInputTool, ...apiAssets.map(convertApiAssetToSidebarItem)];
  const [formFields, setFormFields] = useState({
    patientName: '',
    indication: '',
    frameType: '',
    side: ''
  });

  
  useEffect(() => {

  }, []);

  const handleFormFieldChange = (field, value) => {
    setFormFields(prev => ({
      ...prev,
      [field]: value
    }));


    if (field === 'patientName' || field === 'indication') {

      console.log(`Auto-saved ${field}: ${value}`);
    }
  };
  const renderApiCategories = () => {
    if (loading) {
      return (
        <div className="border-b border-sky-400">
          <div className="bg-sky-400 bg-opacity-80 text-white p-3">
            <span className="text-sm">Loading categories...</span>
          </div>
        </div>
      );
    }

    if (error) {
      return (
        <div className="border-b border-sky-400">
          <div className="bg-red-400 bg-opacity-80 text-white p-3">
            <span className="text-sm">Error loading: {error}</span>
          </div>
        </div>
      );
    }

    if (Object.keys(categories).length === 0) {
      return (
        <div className="border-b border-sky-400">
          <div className="bg-sky-400 bg-opacity-80 text-white p-3">
            <span className="text-sm">No categories found</span>
          </div>
        </div>
      );
    }

    return (
      <>
       

        {/* API Categories */}
        {Object.entries(categories).map(([parentName, group]) => {
          const sectionKey = parentName.toLowerCase().replace(/\s+/g, '');


          return (
            <div key={sectionKey} className="border-b border-sky-400">
              <div
                className="bg-sky-400 bg-opacity-80 text-white p-3 flex justify-between items-center cursor-pointer"
                onClick={() => toggleSection(sectionKey)}
              >
                <span className="font-normal w-[80%] text-sm">{parentName}</span>
                <ChevronDown
                  strokeWidth={3}
                  className={`h-4 w-4 transform mr-2 transition-transform ${expandedSections[sectionKey] ? 'rotate-180' : ''
                    }`}
                />
              </div>

              {expandedSections[sectionKey] && (
                <div className="p-3 mr-[10px]">
                  
                  {Object.entries(group.subcategories).map(([subName, assets]) => {
                    const subKey = `${parentName}-${subName}`.toLowerCase().replace(/\s+/g, '');

                    return (
                      <div key={subKey} className="ml-4 mb-2">
                        <div
                          className="text-white text-xs font-semibold mb-1 flex items-center justify-between cursor-pointer"
                          onClick={() => toggleSubsection(subKey)}
                        >
                          <span className="font-normal w-[80%] text-sm">{subName}</span>
                          <ChevronDown
                            strokeWidth={3}
                            className={`h-3 w-3 transform transition-transform ${expandedSubsections[subKey] ? 'rotate-180' : ''
                              }`}
                          />
                        </div>

                        {expandedSubsections[subKey] && (
                          <div>
                            {assets.map((asset) =>
                              renderSidebarItem(convertApiAssetToSidebarItem(asset))
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}


                  {/* Render parent category assets */}
                  {group.parentAssets.map((asset) =>
                    renderSidebarItem(convertApiAssetToSidebarItem(asset))
                  )}
                </div>
              )}
            </div>
          );
        })}
      </>
    );
  }

  return (
    <div
      className="flex flex-col h-screen bg-cyan-700 bg-opacity-30 bg-center bg-cover bg-no-repeat"
      style={{ backgroundImage: "url('/images/bg.jpg')" }}
      onKeyDown={handleKeyDown}
      tabIndex={0}
    >
      <div className='h-full w-full p-0 pt-4 pb-0 main-builder-wrapper'>
        <div className="flex justify-between mb-4 w-[100%] max-w-[1300px] m-auto">
          <div className="w-16 h-16 rounded-full flex items-center justify-center">
            <img src="/images/logo.png" alt="Logo" className="h-16 w-12 rounded-full" />
          </div>
          <div className="flex flex-row items-center gap-2">
           <div>
      {/* Info button to open modal */}
      <button
        onClick={fetchPDF}
        className="bg-sky-400 hover:bg-blue-600 text-white w-10 h-10 rounded-full flex items-center justify-center transition-colors"
        title="Help"
      >
        <Info size={24} />
      </button>

      {/* Modal */}
      {open && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-xl w-11/12 md:w-3/4 lg:w-2/3 h-[80vh] relative flex flex-col">
            {/* Close button */}
            <button
              onClick={() => setOpen(false)}
              className="absolute top-3 right-3 text-gray-600 hover:text-black"
            >
              <X size={24} />
            </button>

            {/* Title */}
            <div className="p-4 border-b font-semibold text-lg">
             Help / Instructions
            </div>

            {/* Content */}
            <div className="flex-1 overflow-hidden">
              {loading && (
                <div className="flex items-center justify-center h-full">
                  <p>Loading PDF...</p>
                </div>
              )}

              {error && (
                <div className="flex items-center justify-center h-full text-red-600">
                  {error}
                </div>
              )}

              {!loading && pdfUrl && (
                <iframe
                  src={pdfUrl}
                  className="w-full h-full"
                  title="PDF"
                />
              )}
            </div>
          </div>
        </div>
      )}
    </div>

            <button
              onClick={handlePrint}
              className="bg-sky-400 hover:bg-blue-600 text-white w-10 h-10 rounded-full flex items-center justify-center transition-colors"
              title="Print Canvas"
            >
              <Printer size={20} />
            </button>
            <button
              onClick={handleDownload}
              className="bg-sky-400 hover:bg-blue-600 text-white w-10 h-10 rounded-full flex items-center justify-center transition-colors"
              title="Download as PDF"
            >
              <Download size={20} />
            </button>
            
            <button
              className="bg-sky-400 hover:bg-blue-600 text-white w-10 h-10 rounded-full flex items-center justify-center transition-colors"
              onClick={() => setShowModal(true)}
            >
              <LogOut size={20} />
            </button>
      
            
            {showModal && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white rounded-lg p-6 max-w-sm w-full mx-4 shadow-xl">
                  <div className="flex justify-between items-center mb-4">
                    <h2 className="text-lg font-semibold text-gray-800">Confirm Logout</h2>
                    <button
                      onClick={() => setShowModal(false)}
                      className="text-gray-400 hover:text-gray-600 transition-colors"
                    >
                      <X size={20} />
                    </button>
                  </div>

                  <p className="text-gray-600 mb-6">
                    Are you sure you want to logout?
                  </p>

                  <div className="flex gap-3 justify-end">
                    <button
                      onClick={() => setShowModal(false)}
                      className="px-4 py-2 text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleLogout}
                      className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors"
                    >
                      Logout
                    </button>
                    
                  </div>
                </div>
              </div>
            )}
          

          </div>
        </div>

          <div className="flex relative gap-4 justify-between w-[100%] max-w-[1300px] m-auto" style={{ height: 'calc(100vh - 140px)' }}>
        
                        <div className="absolute bottom-[15px] z-10 right-[-20px]  flex flex-col items-end  ">
                          <div className='flex gap-2'>
  <div
          className="p-2 rounded-full bg-sky-400 hover:bg-blue-600 transition cursor-move mb-4"
          title="Text Tool"
          draggable
          onDragStart={(e) => {
            e.stopPropagation();
            e.dataTransfer.setData('text/plain', textInputTool.id);
            handleDragStart(e, textInputTool, 'sidebar');
          }}
        >
          <TypeOutline className="w-5 h-5 text-white" />
        </div>
        </div>
      <div className="flex gap-2">
      
        <button
          onClick={togglePenDropdown}
          className="p-2 rounded-full bg-sky-400 hover:bg-blue-600 transition"
          title="Pen Tool"
        >
          <Pen size={20} className="text-white" />
        </button>
      </div>
      
      {drawingMode === 'pen' && dropdownOpen && (
  <div className="mb-2 bg-white p-3 rounded shadow flex flex-col items-start gap-2 absolute bottom-full right-[10px] w-40  transition-all duration-300">
    {/* Pen Settings */}
    <label className="text-sm font-semibold">Pen Color</label>
    <input
      type="color"
      value={drawingColor}
      onChange={(e) => setDrawingColor(e.target.value)}
      className="w-8 h-8 cursor-pointer"
    />

    <label className="text-sm font-semibold">Line Width</label>
    <select
      value={drawingWidth}
      onChange={(e) => setDrawingWidth(parseInt(e.target.value))}
      className="border rounded p-1 text-sm w-full"
    >
      <option value="1">1px</option>
      <option value="3">3px</option>
      <option value="5">5px</option>
      <option value="8">8px</option>
      <option value="10">10px</option>
    </select>

    <hr className="w-full my-2" />

    <button
      onClick={handleEraser}
      className="flex items-center gap-2 w-full p-1 hover:bg-gray-100 rounded"
      title="Eraser Tool"
    >
      <Eraser size={18} />
      <span className="text-sm">Eraser</span>
    </button>

    <button
      onClick={handleClear}
      className="flex items-center gap-2 w-full p-1 hover:bg-gray-100 rounded"
      title="Clear All"
    >
      <Trash2 size={18} />
      <span className="text-sm">Clear Drawing</span>
    </button>
  </div>
)}

      <button
              className=" mt-4  bg-sky-400 text-white p-2 rounded-full shadow-lg hover:bg-blue-600 transition-colors"
              onClick={() => {
                const drawer = document.getElementById('layers-drawer');
                drawer.classList.toggle('translate-x-full');
              }}
              title="Toggle Layers Panel"
            >
              <ArrowBigLeftDash  size={20} />
            </button>
    </div>
            <div className="w-[16rem] bg-sky-400 bg-opacity-70 overflow-y-auto hide-scrollbar">
              {renderApiCategories()}
            </div>

            <div className="w-[35rem] w-[35rem] lg:[992px-1100px]:w-[43rem] md:w-[64rem] sm:w-[35rem]    flex flex-col overflow-y-auto hide-scrollbar main-center-builder">
 
              <div ref={printRef} data-print-content="true" className="flex-1 pt-6 pb-6 bg-white">

              <div className="max-w-5xl mx-auto mb-6">

                <div className="max-w-6xl mx-auto">
                  <div className="flex lg:flex-row items-start justify-between gap-6 mb-4">

                    <div className="flex-shrink-0 order-1 lg:order-1">
                      <div className="h-48 w-[5rem] flex items-center justify-end mx-auto">
                        <img src="/images/rightleg.png" alt="Right" className="h-44 object-contain mt-[2rem]" crossOrigin="anonymous" />
                      </div>
                    </div>

                    <div className="flex-grow order-3 lg:order-2 w-full">
                      <h2 className="text-2xl font-bold text-center mb-4">
                        Circular Frame Graphic Builder
                      </h2>

                      <div className="flex flex-col  w-full max-w-[500px] mx-auto">

                        {/* Left Column */}
                        <div className="w-full flex flex-col">

                          <div>
                            <div className="flex items-center justify-start mb-2 gap-2">
                              <label className="fixedlabel-width text-sm font-semibold mb-1 hidden md:block">Name or Record:</label>

                              <input
                                type="text"
                                value={formFields.patientName}
                                onChange={(e) => handleFormFieldChange('patientName', e.target.value)}
                                className="w-[70%] builder-input text-base border border-gray-300 rounded-md focus:ring-1 focus:ring-blue-500 focus:outline-none hidden md:block"
                                placeholder="Max 10 letters"
                                maxLength={10}
                              />
                            </div>

                            <div className="text-base text-gray-800 sm:flex sm:gap-2 md:hidden print:ml-[8rem]">
                              <span className="font-medium">Name or Record:</span>
                              <span>{formFields.patientName || 'N/A'}</span>
                            </div>
                          </div>

                          {/* Indication */}
                          <div className="w-full ">
                            <div className="flex items-center justify-start mb-2 gap-2">
                              <label className="fixedlabel-width text-sm font-semibold mb-1 hidden md:block">Indication:</label>

                              <textarea
                                value={formFields.indication}
                                onChange={(e) => handleFormFieldChange('indication', e.target.value)}
                                className="w-[70%] px-4 text-base border border-gray-300 rounded-md focus:ring-1 focus:ring-blue-500 focus:outline-none hidden md:block builder-textarea"
                                placeholder="Up to 50 letters"
                                maxLength={50}
                              />
                            </div>

                            <div className="text-base text-gray-800 sm:flex sm:gap-2 md:hidden print:ml-[8rem]">
                              <span className="font-medium">Indication:</span>
                              <span>{formFields.indication || 'N/A'}</span>
                            </div>
                          </div>

                        </div>

                        {/* Right Column */}
                        <div className="w-full flex flex-col">

                          {/* Frame Type */}
                          <div>
                            <div className="flex items-center justify-start  mb-2 gap-2">
                              <label className="fixedlabel-width text-sm font-semibold mb-2 hidden md:block">Frame Type:</label>

                              <div className="flex flex-row gap-3 hidden md:flex">
                                <label className="flex items-center gap-2 text-sm">
                                  <input
                                    type="checkbox"
                                    checked={formFields.frameType === 'Maxframe'}
                                    onChange={(e) =>
                                      handleFormFieldChange('frameType', e.target.checked ? 'Maxframe' : '')
                                    }
                                  />
                                  Maxframe
                                </label>
                                <label className="flex items-center gap-2 text-sm">
                                  <input
                                    type="checkbox"
                                    checked={formFields.frameType === 'Ilizarov'}
                                    onChange={(e) =>
                                      handleFormFieldChange('frameType', e.target.checked ? 'Ilizarov' : '')
                                    }
                                  />
                                  Ilizarov
                                </label>
                              </div>
                            </div>

                            <div className="text-base text-gray-800 sm:flex sm:gap-2 md:hidden print:ml-[8rem]">
                              <span className="font-medium">Frame Type:</span>
                              <span>{formFields.frameType || 'N/A'}</span>
                            </div>
                          </div>

                          {/* Side */}
                          <div>
                            <div className="flex items-center justify-start  mb-2 gap-2">
                              <label className="fixedlabel-width text-sm font-semibold mb-2 hidden md:block">Side:</label>

                              <div className="flex gap-6 text-base hidden md:flex">
                                <label className="flex items-center gap-2">
                                  <input
                                    type="radio"
                                    name="side"
                                    value="Left"
                                    checked={formFields.side === 'Left'}
                                    onChange={(e) => handleFormFieldChange('side', e.target.value)}
                                  />
                                  Left
                                </label>
                                <label className="flex items-center gap-2">
                                  <input
                                    type="radio"
                                    name="side"
                                    value="Right"
                                    checked={formFields.side === 'Right'}
                                    onChange={(e) => handleFormFieldChange('side', e.target.value)}
                                  />
                                  Right
                                </label>
                              </div>
                            </div>

                            <div className="text-base text-gray-800 sm:flex sm:gap-2 md:hidden print:ml-[8rem]">
                              <span className="font-medium">Side:</span>
                              <span>{formFields.side || 'N/A'}</span>
                            </div>
                          </div>
                        </div>

                      </div>

                    </div>

                    <div className="flex-shrink-0 order-3 lg:order-3">
                      <div className="h-48 w-[5rem] rounded-lg flex items-center justify-start mx-auto">
                        <img src="/images/leftleg.png" alt="Left" className="h-44 object-contain mt-[2rem]" crossOrigin="anonymous" />
                      </div>
                    </div>
                  </div>

                </div>

                {/* Canvas Section with Better Alignment */}
                <div className="flex justify-between pr-[30px] pl-[30px] gap-6 items-start">
                  {/* Left Canvas */}
               <div
  className="w-[9.5rem] h-[28rem] bg-gray-200 flex items-center justify-center print-border"
  onDrop={(e) => handleDrop(e, 'left')}
  onDragOver={handleDragOver}
  ref={leftCanvasRef}
>
  <Stage
    width={150}
    height={448}
    cursor={drawingMode !== 'off' ? pencilCursor : 'default'}
    onMouseDown={(e) => {
      if (drawingMode !== 'off') {
        handleMouseDown(e, 'left');
      } else {
        const clickedOnEmpty = e.target === e.target.getStage();
        if (clickedOnEmpty) {
          setSelectedItemId(null);
        }
      }
    }}
    onMouseMove={(e) => {
      if (drawingMode !== 'off') {
        handleMouseMove(e, 'left');
      }
      setMousePosLeft(e.target.getStage().getPointerPosition());
    }}
    onMouseLeave={(e) => setMousePosLeft({x: -100, y: -100})}
    onMouseUp={() => {
      if (drawingMode !== 'off') {
        handleMouseUp('left');
      }
    }}
     onDblClick={(e) => {
    e.evt.preventDefault();
    e.evt.stopPropagation();
  }}
  onDblTap={(e) => {
    e.evt.preventDefault();
    e.evt.stopPropagation();
  }}
  >
    {/* Items layer */}
    <Layer>
      {leftCanvas
        .slice()
        .sort((a, b) => (a.zIndex || 0) - (b.zIndex || 0))
        .map((item) => {
          if (item.type === 'text') {
            return (
              <TextItem
                key={item.id}
                item={item}
                canvasType="left"
                selectedItemId={selectedItemId}
                setSelectedItemId={setSelectedItemId}
                handleItemUpdate={handleItemUpdate}
                handleItemDelete={handleItemDelete}
                canvasBounds={{ width: 150, height: 448 }}
                setDraggedItem={setDraggedItem}
                drawingMode={drawingMode !== 'off'}
                canvasRef={leftCanvasRef}
              />
            );
          } else {
            return (
              <CanvasItem
                key={item.id}
                item={item}
                canvasType="left"
                selectedItemId={selectedItemId}
                setSelectedItemId={setSelectedItemId}
                handleItemUpdate={handleItemUpdate}
                handleItemDelete={handleItemDelete}
                canvasBounds={{ width: 150, height: 448 }}
                setDraggedItem={setDraggedItem}
                drawingMode={drawingMode !== 'off'}
              />
            );
          }
        })}
      {leftCanvas.length === 0 && (
        <Text
        text='Drag and Drop
"AP view of Tib"'          x={0}
          y={210}
          width={150}
          fontSize={12}
          fill="red"
          align="center"
          lineHeight={1.5}
        />
      )}
    </Layer>

    {/* Drawing layer */}
    <Layer>
      {/* Saved lines */}
      {lines
        .filter((line) => line.canvasType === 'left')
        .map((line, i) => (
          <Line
            key={`line-left-${i}`}
            points={line.points}
            stroke={line.color}
            strokeWidth={line.width}
            tension={0.5}
            lineCap="round"
            lineJoin="round"
            globalCompositeOperation={
              line.color === '#ffffff' ? 'destination-out' : 'source-over'
            }
          />
        ))}

  {/* Current line */}
  {currentLine && currentLine.canvasType === 'left' && (
    <Line
      points={currentLine.points}
      stroke={currentLine.color}
      strokeWidth={currentLine.width}
      tension={0.5}
      lineCap="round"
      lineJoin="round"
      globalCompositeOperation={
        currentLine.color === '#ffffff' ? 'destination-out' : 'source-over'
      }
    />
  )}
  {drawingMode !== 'off' && <Text text="✏️" x={mousePosLeft.x - 10} y={mousePosLeft.y - 10} fontSize={20} />}
</Layer>
  </Stage>
</div>


                  {/* Main Canvas - Bigger */}
              <div className="w-[38rem] h-[28rem] bg-white flex items-center justify-center print-border main-konva-canvas"
  onDrop={(e) => handleDrop(e, 'main')}
  onDragOver={handleDragOver}
  ref={canvasRef}
>
  <Stage
    width={636}
    height={440}
    cursor={drawingMode !== 'off' ? pencilCursor : 'default'}
    onMouseDown={(e) => {
      // Handle drawing if in drawing mode
      if (drawingMode !== 'off') {
        handleMouseDown(e, 'main');
      } else {
        // Deselect if user clicks on empty area (not inside a shape)
        const clickedOnEmpty = e.target === e.target.getStage();
        if (clickedOnEmpty) {
          setSelectedItemId(null);
        }
      }
    }}
    onMouseMove={(e) => {
      if (drawingMode !== 'off') {
        handleMouseMove(e, 'main');
      }
      setMousePosMain(e.target.getStage().getPointerPosition());
    }}
    onMouseLeave={(e) => setMousePosMain({x: -100, y: -100})}
    onMouseUp={() => {
      if (drawingMode !== 'off') {
        handleMouseUp('main');
      }
    }}
     onDblClick={(e) => {
    e.evt.preventDefault();
    e.evt.stopPropagation();
  }}
  onDblTap={(e) => {
    e.evt.preventDefault();
    e.evt.stopPropagation();
  }}
  >
    {/* Layer for canvas items */}
    <Layer>
      {canvas
        .slice() // copy to avoid mutating original
        .sort((a, b) => (a.zIndex || 0) - (b.zIndex || 0)) // bottom to top
        .map((item) => {
          if (item.type === 'text') {
            return (
              <TextItem
                key={item.id}
                item={item}
                canvasType="main"
                selectedItemId={selectedItemId}
                setSelectedItemId={setSelectedItemId}
                handleItemUpdate={handleItemUpdate}
                handleItemDelete={handleItemDelete}
                canvasBounds={{ width: 636, height: 448 }}
                setDraggedItem={setDraggedItem}
                drawingMode={drawingMode !== 'off'}
                canvasRef={canvasRef}
              />
            );
          } else {
            return (
              <CanvasItem
                key={item.id}
                item={item}
                canvasType="main"
                canvasBounds={{ width: 636, height: 448 }}
                selectedItemId={selectedItemId}
                setSelectedItemId={setSelectedItemId}
                handleItemUpdate={handleItemUpdate}
                handleItemDelete={handleItemDelete}
                setDraggedItem={setDraggedItem}
                drawingMode={drawingMode !== 'off'}
              />
            );
          }
        })}
      {canvas.length === 0 && (
        <Text
          text="Drag and drop appropriate cross sections and fixation elements to show how you transfixed at each ring level"
          x={0}
          y={210}
          width={636}
          fontSize={12}
          wrap='word'
          fill="gray"
          align="center"
          lineHeight={1.5}
        />
      )}
    </Layer>

    {/* Separate layer for drawings (on top of items) */}
    <Layer>
      {/* Render saved lines */}
      {lines
        .filter(line => line.canvasType === 'main')
        .map((line, i) => (
          <Line
            key={`line-${i}`}
            points={line.points}
            stroke={line.color}
            strokeWidth={line.width}
            tension={0.5}
            lineCap="round"
            lineJoin="round"
            globalCompositeOperation={
              line.color === '#ffffff' ? 'destination-out' : 'source-over'
            }
          />
        ))}
      
  {/* Render current line being drawn */}
  {currentLine && currentLine.canvasType === 'main' && (
    <Line
      points={currentLine.points}
      stroke={currentLine.color}
      strokeWidth={currentLine.width}
      tension={0.5}
      lineCap="round"
      lineJoin="round"
      globalCompositeOperation={
        currentLine.color === '#ffffff' ? 'destination-out' : 'source-over'
      }
    />
  )}
  {drawingMode !== 'off' && <Text text="✏️" x={mousePosMain.x - 10} y={mousePosMain.y - 10} fontSize={20} />}
</Layer>
  </Stage>
</div>

                  {/* Right Canvas */}
                 <div
  className="w-[9.5rem] h-[28rem] bg-gray-200 flex items-center justify-center print-border overflow-visible"
  onDrop={(e) => handleDrop(e, 'right')}
  onDragOver={handleDragOver}
  ref={rightCanvasRef}
>
  <Stage
    width={150}
    height={448}
    cursor={drawingMode !== 'off' ? pencilCursor : 'default'}
    onMouseDown={(e) => {
      if (drawingMode !== 'off') {
        handleMouseDown(e, 'right');
      } else {
        const clickedOnEmpty = e.target === e.target.getStage();
        if (clickedOnEmpty) {
          setSelectedItemId(null);
        }
      }
    }}
    onMouseMove={(e) => {
      if (drawingMode !== 'off') {
        handleMouseMove(e, 'right');
      }
      setMousePosRight(e.target.getStage().getPointerPosition());
    }}
    onMouseLeave={(e) => setMousePosRight({x: -100, y: -100})}
    onMouseUp={() => {
      if (drawingMode !== 'off') {
        handleMouseUp('right');
      }
    }}
     onDblClick={(e) => {
    e.evt.preventDefault();
    e.evt.stopPropagation();
  }}
  onDblTap={(e) => {
    e.evt.preventDefault();
    e.evt.stopPropagation();
  }}
  >
    {/* Layer for canvas items */}
    <Layer>
      {rightCanvas
        .slice()
        .sort((a, b) => (a.zIndex || 0) - (b.zIndex || 0))
        .map((item) => {
          if (item.type === 'text') {
            return (
              <TextItem
                key={item.id}
                item={item}
                canvasType="right"
                selectedItemId={selectedItemId}
                setSelectedItemId={setSelectedItemId}
                handleItemUpdate={handleItemUpdate}
                handleItemDelete={handleItemDelete}
                canvasBounds={{ width: 150, height: 448 }}
                setDraggedItem={setDraggedItem}
                drawingMode={drawingMode !== 'off'}
                canvasRef={rightCanvasRef}
              />
            );
          } else {
            return (
              <CanvasItem
                key={item.id}
                item={item}
                canvasType="right"
                canvasBounds={{ width: 150, height: 448 }}
                selectedItemId={selectedItemId}
                setSelectedItemId={setSelectedItemId}
                handleItemUpdate={handleItemUpdate}
                handleItemDelete={handleItemDelete}
                setDraggedItem={setDraggedItem}
                drawingMode={drawingMode !== 'off'}
              />
            );
          }
        })}
      {rightCanvas.length === 0 && (
        <Text
           text='Drag and Drop
"AP view of Tib"'
          x={0}
          y={210}
          width={150}
          fontSize={12}
          fill="red"
          align="center"
          lineHeight={1.5}
          listening={false}
          globalCompositeOperation="destination-over"
        />
      )}
    </Layer>

    {/* Drawing layer */}
    <Layer>
      {lines
        .filter((line) => line.canvasType === 'right')
        .map((line, i) => (
          <Line
            key={`line-right-${i}`}
            points={line.points}
            stroke={line.color}
            strokeWidth={line.width}
            tension={0.5}
            lineCap="round"
            lineJoin="round"
            globalCompositeOperation={
              line.color === '#ffffff' ? 'destination-out' : 'source-over'
            }
          />
        ))}

  {currentLine && currentLine.canvasType === 'right' && (
    <Line
      points={currentLine.points}
      stroke={currentLine.color}
      strokeWidth={currentLine.width}
      tension={0.5}
      lineCap="round"
      lineJoin="round"
      globalCompositeOperation={
        currentLine.color === '#ffffff' ? 'destination-out' : 'source-over'
      }
    />
  )}
  {drawingMode !== 'off' && <Text text="✏️" x={mousePosRight.x - 10} y={mousePosRight.y - 10} fontSize={20} />}
</Layer>
  </Stage>
</div>

                </div>
              </div>
            </div>
          </div>

          <DndProvider backend={HTML5Backend}>
            {/* Right Side Drawer */}
              
            <div 
              id="layers-drawer"
              className="fixed top-0 right-0 h-full w-[280px] bg-white shadow-xl transform translate-x-full transition-transform duration-300 ease-in-out z-40"
            >
              <div className="h-full flex flex-col">
                {/* Drawer Header */}
                <div className="bg-sky-500 text-white p-4 flex justify-between items-center">
                  <h2 className="text-lg font-semibold">Layers</h2>
                  <button
                    className="text-white hover:text-gray-200"
                    onClick={() => {
                      const drawer = document.getElementById('layers-drawer');
                      drawer.classList.add('translate-x-full');
                    }}
                  >
                    <X size={20} />
                  </button>
                </div>

                {/* Drawer Content */}
                <div className="flex-1 overflow-y-auto">
                  {canvas.length === 0 && leftCanvas.length === 0 && rightCanvas.length === 0 && (
                    <div className="p-4 text-center">
                      <p className="text-sm text-gray-500">
                        No layers yet. Drag and drop items into the canvas to begin.
                      </p>
                    </div>
                  )}

                  {canvas.length > 0 && (
                    <>
                      <div className="px-3 py-2 bg-gray-100 border-b">
                        <h3 className="text-sm font-medium text-gray-700">Main Canvas</h3>
                      </div>
                      <LayerPanelMainCanvas
                        canvasItems={canvas}
                        setCanvasItems={setCanvas}
                        selectedItemId={selectedItemId}
                        onSelect={(id) => setSelectedItemId(id)}
                        onDelete={(id) => handleItemDelete(id, 'main')}
                        onToggleVisibility={toggleVisibility}
                        onToggleLock={toggleLock} // ADD THIS
                        onReorderLayers={setCanvas}
                      />
                    </>
                  )}

                  {leftCanvas.length > 0 && (
                    <>
                      <div className="px-3 py-2 bg-gray-100 border-b">
                        <h3 className="text-sm font-medium text-gray-700">Left Canvas</h3>
                      </div>
                      <LayerPanelMainCanvas
                        canvasItems={leftCanvas}
                        setCanvasItems={setLeftCanvas}
                        selectedItemId={selectedItemId}
                        onSelect={(id) => setSelectedItemId(id)}
                        onDelete={(id) => handleItemDelete(id, 'left')}
                        onToggleVisibility={toggleLeftVisibility}
                        onToggleLock={toggleLeftLock} // ADD THIS
                        onReorderLayers={setLeftCanvas}
                      />
                    </>
                  )}

                  {rightCanvas.length > 0 && (
                    <>
                      <div className="px-3 py-2 bg-gray-100 border-b">
                        <h3 className="text-sm font-medium text-gray-700">Right Canvas</h3>
                      </div>
                      <LayerPanelMainCanvas
                        canvasItems={rightCanvas}
                        setCanvasItems={setRightCanvas}
                        selectedItemId={selectedItemId}
                        onSelect={(id) => setSelectedItemId(id)}
                        onDelete={(id) => handleItemDelete(id, 'right')}
                        onToggleVisibility={toggleRightVisibility}
                        onToggleLock={toggleRightLock} // ADD THIS
                        onReorderLayers={setRightCanvas}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* Overlay for closing drawer on outside click */}
            <div 
              id="drawer-overlay"
              className="fixed inset-0 bg-black bg-opacity-50 z-30 hidden"
              onClick={() => {
                const drawer = document.getElementById('layers-drawer');
                drawer.classList.add('translate-x-full');
                const overlay = document.getElementById('drawer-overlay');
                overlay.classList.add('hidden');
              }}
            />
          </DndProvider>

        </div>

      </div>
      <div className="p-2 border-gray-200">
        <div className="flex justify-center">
          <span className="text-base text-white"> &copy; {new Date().getFullYear()} Circularframebuilder. All Rights Reserved.</span>
        </div>
      </div>

    </div>
  );
}